export default __webpack_public_path__ + "static/MonumentGrotesk-Medium-f48c16f169d06cfa54dfab1e9605ad50.ttf";